import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { format } from 'date-fns';

import html2pdf from "html2pdf.js";
import dayjs from "dayjs";
import commonLabels from "../../../common/labels/common_en.json";
import ApprovalVersionMismatchEntity from "../../components/examReport/ApprovalVersionMismatchEntity";
import TablePagination from "../../../common/components/TablePagination";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
  getSubjectlistByExamId,
  getVersionMismatchList,
  saveVersionMismatch,
  getDownloadVersionMismatch,
  getAllUnApproveVersionMismatchListPagination,
  objetiveStatusLockUnlock,
  getObjectiveStatus,
  getObjectiveStatusflag,
} from "../../actions/postExaminationProcessObjectiveActions";
import { set } from "lodash";
import { getYearList, getAdvertisementlistByYear } from "../../../common/actions/commonActions";
import { SET_OBJECTIVE_STATUS_DATA_FLAG, SET_PROCESS_LOCK_STATE, SET_VERSION_MISMATCH_LIST } from "../../../common/constants/ActionTypes";
import InvigilatorVersionMismatch from "./InvigilatorVersionMismatch";
import { toastr } from "react-redux-toastr";
import FileViewModal from "../../../common/components/FileViewModal";

const VersionMismatch = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  const [selectedYear, setSelectedYear] = useState("");
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [requestData, setRequestData] = useState([]);
  const [stepName, setName] = useState("list");
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [isEditable, setIsEditable] = useState(false);
  let [isEdit, setIsEdit] = useState(false);
  let [isPrint, setIsPrint] = useState(false);
  const dispatch = useDispatch();
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [isAllICRBlank, setIsAllICRBlank] = useState(true);
  let [isAllOMRBlank, setIsAllOMRBlank] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [isSave, setIsSave] = useState(false);
  const [flagArray, setFlagArray] = useState([]);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [viewImageModal, setViewImageModal] = useState(false);
  const [selectedImageContent, setSelectedImageContent] = useState("");
  const date = new Date(); // Your date object here
  const formattedDate = format(date, 'MM/dd/yyyy');
  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];
  let rowPerPage = 10;
  const length = 50;

  useEffect(() => { }, [reloadItem]);

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };
  useEffect(() => {
    if (stepName == "unapproved") {
      dispatch(getAllUnApproveVersionMismatchListPagination(listCurrentPage, rowPerPage));
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getYearList());
    setRequestData([]);

    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onCancelButton();
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA_FLAG,
    });
    flagArray.length = 0;
  }, [stepName]);

  let {
    examList,
    advertisementList,
    subjectList,
    unapprovalVersionMismatchPageNoCounter,
    versionMismatchList,
    allUnapprovalVersionMismatchList,
    objectiveStatusData, objectiveStatusDataFlag
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, allYearList, processLockState } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  useEffect(() => {
    setFlagArray([]);
    if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
      const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
      const flagArrayBeforeInterviewCriteria = [];

      // for (let i = 0; i < flagValues.length; i++) {
      //   if (flagValues[i] === "Version Mismatch") {
      //     setFlagArray(flagArrayBeforeInterviewCriteria);
      //     break;
      //   } else {
      //     flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
      //   }
      // }
      for (let i = 0; i < flagValues.length; i++) {
        if (flagValues[i] === "Version Mismatch") {
          setFlagArray(flagArrayBeforeInterviewCriteria);
          break;
        } else {
          if (objectiveStatusDataFlag[i].flagStatus === true) {
            flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
          }
        }
      }
      if (flagArrayBeforeInterviewCriteria.some(item => item.flagStatus === false)) {
        toastr.warning(label.UPLOAD_CSV_MESSAGE);
      }
    }
  }, [objectiveStatusDataFlag]);
  useEffect(() => {
    if (versionMismatchList && versionMismatchList.versionList && versionMismatchList.versionList.length > 0) {
      setIsEdit(true);
    }
  }, [versionMismatchList])
  let tableCounter_unapproval = unapprovalVersionMismatchPageNoCounter + 1;
  const onSubmit = () => {
    setIsEditable(false);
    setIsPrint(true);
    let newData = [];
    requestData && requestData.length > 0 && requestData.map((data, ind) => {
      data && data.length > 0 && data.map((ele, index) => {
        newData.push(ele);
      })
    });

    newData.sort((a, b) => a.rollNo.localeCompare(b.rollNo));
    versionMismatchList.versionList = newData;
    dispatch(saveVersionMismatch(newData, selectedExam, selectedSubject));

    setReloadItem(!reloadItem);
  };

  useEffect(() => {

    setRequestData([]);
    let newRequestData = [];
    let newRequestData1 = [];
    let newRequestData2 = [];
    let newRequestData3 = [];
    versionMismatchList && versionMismatchList.versionList && versionMismatchList.versionList.length > 0 && versionMismatchList.versionList.map((ele, index) => {

      if ((ele.icr != "" && ele.icr != 0 && ele.icr != null) && (ele.omr != "" && ele.omr != 0 && ele.omr != null)) {
        let newObj = {
          "id": ele.id,
          "rollNo": ele.rollNo,
          "icr": ele.icr,
          "omr": ele.omr
        };
        newRequestData.push(newObj);
      }
      else if ((ele.icr != "" && ele.icr != 0 && ele.icr != null) && (ele.omr == "" || ele.omr == 0 || ele.omr == null)) {
        let newObj = {
          "id": ele.id,
          "rollNo": ele.rollNo,
          "icr": ele.icr,
          "omr": ele.omr
        };
        newRequestData1.push(newObj);
      }
      else if ((ele.icr == "" || ele.icr == 0 || ele.icr == null) && (ele.omr != "" && ele.omr != 0 && ele.omr != null)) {
        let newObj = {
          "id": ele.id,
          "rollNo": ele.rollNo,
          "icr": ele.icr,
          "omr": ele.omr
        };
        newRequestData2.push(newObj);
      }
      else {
        let newObj = {
          "id": ele.id,
          "rollNo": ele.rollNo,
          "icr": ele.icr,
          "omr": ele.omr
        };
        newRequestData3.push(newObj);
      }


    })
    let mergedArray = [];
    mergedArray[0] = newRequestData;
    mergedArray[1] = newRequestData1;
    mergedArray[2] = newRequestData2;
    mergedArray[3] = newRequestData3;
    setRequestData(mergedArray);
    setReloadItem(!reloadItem);
  }, [versionMismatchList]);

  const onSubjectChange = (e) => {
    let selectedValue = e.target.value;
    setSelectedSubject(selectedValue);
    versionMismatchList = '';
    selectedValue && dispatch(getVersionMismatchList(selectedExam, selectedValue));
    setIsEditable(false);
    setRequestData([]);
    setIsEdit(true);
    setReloadItem(!reloadItem);
    setIsPrint(false);
    setSaveButtonFlag(false);
    if (requestData && !(requestData.length > 0)) {
      setIsEdit(false);
    }
    // else if(requestData && (requestData.length > 0)){
    //   setIsEdit(true);
    // }
  };

  const onChangeVersionOMR = (val, rollno) => {
    let newData = requestData;
    requestData && requestData.length > 0 && requestData.map((ele, index) => {
      ele && ele.length > 0 && ele.map((eleN, indexN) => {
        if (rollno == eleN.rollNo) {
          newData[index][indexN].omr = val;
        }
      })
    })
    setRequestData(newData);
    setReloadItem(!reloadItem);


  };
  const onCancelButton = () => {
    setSelectedYear("");
    setSelectedAdvertNo("");
    setSelectedSubject("");
    setSelectedExam("");
    allYearList.length = 0;
    examList.length = 0;
    subjectList.length = 0;
    versionMismatchList = '';
    setRequestData([]);
    setFlagArray([]);
    setSaveButtonFlag(true);
    setIsEditable(false);
    setIsPrint(false);
    setIsEdit(false);
    reset();
    setReloadItem(!reloadItem);

  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    Promise.resolve()
      .then(() => {

        setSelectedExam(selectedValue);
        subjectList.length = 0;
        versionMismatchList = '';
        setRequestData([]);
        setIsEdit(false);
        setIsPrint(false);
        setSaveButtonFlag(true);
        setIsEditable(false);
        dispatch({
          type: SET_PROCESS_LOCK_STATE,
          payload: {
            ...processLockState,
            versionMismatch: false
          }
        });


        if (selectedValue) {
          return dispatch(getObjectiveStatus(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        if (selectedValue) {
          return dispatch(getSubjectlistByExamId(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        if (selectedValue) {
          return dispatch(getObjectiveStatusflag(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        setReloadItem((prev) => !prev);
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };

  const onChangeVersionICR = (val, rollno) => {
    let newData = requestData;

    requestData && requestData.length > 0 && requestData.map((ele, index) => {
      ele && ele.length > 0 && ele.map((eleN, indexN) => {
        if (rollno == eleN.rollNo) {
          newData[index][indexN].icr = val;
        }
      })
    })
    setRequestData(newData);
    setReloadItem(!reloadItem);
  };

  const printVersionMismatchPdf = () => {
    genPdf();
    //dispatch(getDownloadVersionMismatch());
  }
  const handleReset = () => {
    // reset();
  }
  const handleLockUnlock = (lock) => {
    selectedExam && dispatch(
      objetiveStatusLockUnlock(selectedExam, 'versionmismatch', lock, selectedSubject, handleReset)
    );
    // reset();
  }

  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><div class="col-md-12 text-center text-uppercase"><h4>' + commonLabels.MPSC + '</h4><h5>' + versionMismatchList.examName + '</h5><h5>' + versionMismatchList.subjectName + '</h5><h5>' + commonLabels.VersionMismatchPdfTitle + '</h5></div></div>';

    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "versionMismatch.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, textX, textY);

          const ad = versionMismatchList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save("versionMismatch.pdf");
      });
  };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    setSelectedYear(selectedValue);
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0
    }
    if (examList) {
      examList.length = 0;
    }
    if (subjectList) {
      subjectList.length = 0;
    }
    dispatch({
      type: SET_VERSION_MISMATCH_LIST,
      payload: []
    })
    setSaveButtonFlag(true);
    setFlagArray([]);
    setIsEdit(false);
    setReloadItem(!reloadItem);
    setIsPrint(false);
  };

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    setSelectedExam("");
    setFlagArray([]);
    examList.length = 0;
    subjectList.length = 0;
    versionMismatchList = '';
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setRequestData([]);
    setReloadItem(!reloadItem);
    setIsEdit(false);
    setIsPrint(false);
  };

  const isValidICR = (value) => {
    const regex = /^(0|A|B|C|D|AB|BC|CD|DA)$/;
    return regex.test(value);
  };

  const onEdit = () => {
    setIsEditable(true);
    setIsSave(true);
  }

  const handleViewFile = (sheetId) => {
    setSelectedImageContent(sheetId);
    setViewImageModal(true);
  };

  return (
    <div className="dashboardContentArea">
      <h5 className="labelMargin"> {label.VersionMismatch} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "list"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="list"
              id="list-tab"
              onClick={() => setName("list")}
              data-toggle="tab"
              role="tab"
              aria-controls="list"
              aria-selected="false"
            >
              <span>{label.VersionMismatchList}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "unapproved"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="unapproved"
              id="unapproved-tab"
              onClick={() => setName("unapproved")}
              data-toggle="tab"
              role="tab"
              aria-controls="unapproved"
              aria-selected="false"
            >
              <span>{label.UnapprovedVersionMismatchList}</span>
            </a>
          </li>
          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "invigilator"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="invigilator"
              id="invigilator-tab"
              onClick={() => setName("invigilator")}
              data-toggle="tab"
              role="tab"
              aria-controls="invigilator"
              aria-selected="false"
            >
              <span>{label.InvigilatorVersionMismatchList}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "list"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="list"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList
                              .map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                        </select>
                        {_.get("selectedYear.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allYearList &&
                            allYearList.length > 0 &&
                            allYearList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index + 1} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectSubject}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedSubject"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSubjectChange(e);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {subjectList &&
                            subjectList.length > 0 &&
                            subjectList
                              // .filter(
                              //   (element) =>
                              //     element.isDeleted === false &&
                              //     element.isActive === true
                              // )
                              .map((element, index) => (
                                <option key={index + 1} value={element.id}>
                                  {element.name}({element.type?.toUpperCase()})
                                </option>
                              ))}
                        </select>
                        {_.get("selectedSubject.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                    </div>

                    <div className="row pl-3 pr-3">
                      {/* {flagArray &&
                        flagArray.length > 0 &&
                        flagArray.map((ele, index) => (
                          <div className="d-flex p-2" key={index}>
                            <input
                              type="checkbox"
                              disabled
                              checked={ele.flagStatus === true && true}
                              className="form-control"
                            />
                            <label className="ml-1">{ele.flag}</label>
                          </div>
                        ))} */}
                      {flagArray &&
                        flagArray.length > 0 &&
                        flagArray
                          .filter((ele) => {
                            if (ele.flag === "Marks" || ele.flag === "Marks Criteria") {
                              return false;
                            }
                            return true;
                          })
                          .map((ele, index) => (
                            <div className="d-flex p-2" key={index}>
                              <input
                                type="checkbox"
                                disabled
                                checked={ele.flagStatus}
                                className="form-control"
                              />
                              <label className="ml-1">{ele.flag}</label>
                            </div>
                          ))}
                    </div>


                    <div className="row">
                      <div className="form-group col-md-6">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          onClick={() => onEdit()}
                          disabled={!isEdit || !versionMismatchList.versionList}
                        >
                          {commonLabels.BUTTON_EDIT}
                        </button>
                        {isEditable == true ?
                          // <div className="row">
                          //   <div className="form-group col-md-6">

                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            disabled={!isSave}
                            onClick={(e) =>
                              onSubmit(e)}>
                            {commonLabels.BUTTON_SAVE}
                          </button>
                          //   </div>
                          // </div>
                          : ""}
                        {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || isEditable || !versionMismatchList.versionList}
                          onClick={() => printVersionMismatchPdf()}
                        >
                          {commonLabels.BUTTON_PRINT}
                        </button>}

                        {/* {(session.roleName == 'superadmin' || session.roleName == 'secretary') &&
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            disabled={(objectiveStatusData.flgVersionMismatchLocked !== null && objectiveStatusData.flgVersionMismatchLocked !== true && objectiveStatusData.flgVersionMismatchLocked !== false) || saveButtonFlag || !versionMismatchList.versionList ||

                              (
                                !objectiveStatusData.flgVersionMismatchLocked &&
                                versionMismatchList &&
                                versionMismatchList.versionList &&
                                versionMismatchList.versionList.length > 0
                              )}
                            onClick={() => {
                              handleLockUnlock(!objectiveStatusData.flgVersionMismatchLocked);
                            }}
                          >

                            {!objectiveStatusData.flgVersionMismatchLocked && commonLabels.BUTTON_LOCK}
                            {objectiveStatusData.flgVersionMismatchLocked && commonLabels.BUTTON_UNLOCK}
                          </button>
                        } */}
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className={`btn mr-2 ${processLockState.versionMismatch
                                ? "btn-lock-green"
                                : "btn-unlock-red"
                                }`}
                              style={{
                                borderRadius: "0.60rem",
                              }}
                              disabled={
                                saveButtonFlag ||
                                !versionMismatchList.versionList ||
                                (
                                  !processLockState.versionMismatch &&
                                  versionMismatchList &&
                                  versionMismatchList.versionList &&
                                  versionMismatchList.versionList.length > 0
                                )
                              }
                              onClick={() => {
                                const newState = !processLockState.versionMismatch;

                                dispatch({
                                  type: SET_PROCESS_LOCK_STATE,
                                  payload: {
                                    ...processLockState,
                                    versionMismatch: newState,
                                  },
                                });

                                handleLockUnlock(newState);
                              }}
                            >
                              {processLockState.versionMismatch
                                ? commonLabels.BUTTON_UNLOCK
                                : commonLabels.BUTTON_LOCK}
                            </button>
                          )}
                        {/* {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <>
                              {!(confirmClicked
                                ? objectiveStatusData.flgVersionMismatchLocked
                                : false) ? (
                                <button
                                  type="button"
                                  className="btn mr-2"
                                  style={{
                                    backgroundColor: "green",
                                    color: "white",
                                    borderColor: "green",
                                  }}
                                  disabled={
                                    saveButtonFlag ||
                                    isEditable ||
                                    !versionMismatchList.versionList ||

                                    (
                                      versionMismatchList &&
                                      versionMismatchList.versionList &&
                                      versionMismatchList.versionList.length > 0
                                    )
                                  }
                                  onClick={() => {
                                    setConfirmClicked(true);
                                    handleLockUnlock(true);
                                  }}
                                >
                                  {commonLabels.BUTTON_LOCK}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn mr-2"
                                  style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    borderColor: "red",
                                  }}
                                  disabled={isEditable}
                                  onClick={() => handleLockUnlock(false)}
                                >
                                  {commonLabels.BUTTON_UNLOCK}
                                </button>
                              )}
                            </>
                          )} */}

                      </div>
                    </div>
                    {((versionMismatchList &&
                      versionMismatchList.versionList != null)) && (
                        <div ref={pdfRef} id="versionMismatchData" >
                          {requestData && requestData.length > 0 && requestData.map((version, ind) => (
                            <div key={ind}>
                              {(ind == 0 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle}</h5> : ""}
                              {(ind == 1 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle1}</h5> : ""}
                              {(ind == 2 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle2}</h5> : ""}
                              {(ind == 3 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle3}</h5> : ""}
                              {version && version.length > 0 &&
                                <div className="row">
                                  <div className="col-md-12">
                                    <table className="table w-100">
                                      <tbody>
                                        <tr>
                                          <td className="w-50">
                                            {version && version.length > 0 &&
                                              <table className="table table-bordered">
                                                <thead className="thead-light">

                                                  <tr  >
                                                    <th scope="col " rowSpan={2} className="text-center">{commonLabels.SrNo}</th>
                                                    <th scope="col " rowSpan={2}>{label.RollNo}</th>
                                                    <th scope="col text-center" colSpan={2} >{label.CandidateLabel}</th>
                                                  </tr>
                                                  <tr>
                                                    <th scope="col ">{label.VersionICR}</th>
                                                    <th scope="col ">{label.VersionOMR}</th>
                                                  </tr>

                                                </thead>
                                                <tbody className="table-font-12">
                                                  {version && version.length > 0 &&
                                                    version.map((ele, index) => {
                                                      if (index % 2 == 0) {
                                                        return (
                                                          <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            {/* <td className="text-center">{ele.rollNo}</td> */}
                                                            <td
                                                              className="text-center text-primary"
                                                              style={{ cursor: "pointer" }}
                                                              onClick={() => handleViewFile(ele.sheetId)}
                                                            >
                                                              {ele.rollNo}
                                                            </td>
                                                            <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  value={ele.icr}
                                                                  onChange={(e) => {
                                                                    const input = e.target.value.toUpperCase();
                                                                    onChangeVersionICR(
                                                                      input,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                  onKeyDown={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];
                                                                    const isControlKey =
                                                                      e.key === "Backspace" ||
                                                                      e.key === "Delete" ||
                                                                      e.key === "ArrowLeft" ||
                                                                      e.key === "ArrowRight" ||
                                                                      e.ctrlKey;
                                                                    if (!isControlKey &&
                                                                      (!allowedChars.includes(input) || e.target.value.length >= 2)) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  defaultValue={ele.icr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionICR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }
                                                            </td>
                                                            <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  value={ele.omr}
                                                                  onChange={(e) => {
                                                                    const input = e.target.value.toUpperCase();
                                                                    onChangeVersionOMR(
                                                                      input,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                  onKeyDown={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];
                                                                    const isControlKey =
                                                                      e.key === "Backspace" ||
                                                                      e.key === "Delete" ||
                                                                      e.key === "ArrowLeft" ||
                                                                      e.key === "ArrowRight" ||
                                                                      e.ctrlKey;

                                                                    if (!isControlKey &&
                                                                      (!allowedChars.includes(input) || e.target.value.length >= 2)) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  defaultValue={ele.omr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionOMR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }

                                                            </td>
                                                          </tr>
                                                        );
                                                      }

                                                    })}
                                                </tbody>
                                              </table>
                                            }
                                          </td>
                                          <td className="w-50">
                                            {version && version.length > 1 &&
                                              <table className="table table-bordered">
                                                <thead className="thead-light">

                                                  <tr  >
                                                    <th scope="col " rowSpan={2} className="text-center">{commonLabels.SrNo}</th>
                                                    <th scope="col " rowSpan={2}>{label.RollNo}</th>
                                                    <th scope="col text-center" colSpan={2} >{label.CandidateLabel}</th>
                                                  </tr>
                                                  <tr>
                                                    <th scope="col ">{label.VersionICR}</th>
                                                    <th scope="col ">{label.VersionOMR}</th>
                                                  </tr>

                                                </thead>
                                                <tbody className="table-font-12">
                                                  {version && version.length > 1 &&
                                                    version.map((ele, index) => {
                                                      if (index % 2 != 0) {
                                                        return (
                                                          <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">{ele.rollNo}</td>
                                                            <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  value={ele.icr}
                                                                  onChange={(e) => {
                                                                    const input = e.target.value.toUpperCase();
                                                                    onChangeVersionICR(
                                                                      input,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                  onKeyDown={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];
                                                                    const isControlKey =
                                                                      e.key === "Backspace" ||
                                                                      e.key === "Delete" ||
                                                                      e.key === "ArrowLeft" ||
                                                                      e.key === "ArrowRight" ||
                                                                      e.ctrlKey;

                                                                    if (!isControlKey &&
                                                                      (!allowedChars.includes(input) || e.target.value.length >= 2)) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  defaultValue={ele.icr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionICR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }
                                                            </td>
                                                            <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  value={ele.omr}
                                                                  onChange={(e) => {
                                                                    const input = e.target.value.toUpperCase();
                                                                    onChangeVersionOMR(input, ele.rollNo);
                                                                  }}
                                                                  onKeyDown={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];
                                                                    const isControlKey =
                                                                      e.key === "Backspace" ||
                                                                      e.key === "Delete" ||
                                                                      e.key === "ArrowLeft" ||
                                                                      e.key === "ArrowRight" ||
                                                                      e.ctrlKey;

                                                                    if (!isControlKey &&
                                                                      (!allowedChars.includes(input) || e.target.value.length >= 2)) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  defaultValue={ele.omr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionOMR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }
                                                            </td>
                                                          </tr>
                                                        );
                                                      }

                                                    })}
                                                </tbody>
                                              </table>
                                            }
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              }

                            </div>
                          ))}




                        </div>
                      )}

                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "unapproved"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="unapproved"
            role="tabpanel"
            aria-labelledby="unapproved-tab"
          >
            {allUnapprovalVersionMismatchList &&
              allUnapprovalVersionMismatchList.entityApprovalDtoList &&
              allUnapprovalVersionMismatchList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}>
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>

                    {allUnapprovalVersionMismatchList &&
                      allUnapprovalVersionMismatchList.entityApprovalDtoList &&
                      allUnapprovalVersionMismatchList.entityApprovalDtoList.length > 0 &&
                      allUnapprovalVersionMismatchList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className="word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className="width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className="word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>

                              <td className="w-10 word-break width-20">
                                {ele.entityApprovalAction.entityApprovalDto.detail &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.exam.name}{" "}
                                <br />{" "}
                                {ele.entityApprovalAction.entityApprovalDto.detail &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.exam.nameDvng}
                              </td>
                              <td className="w-10 word-break  width-12">
                                {ele.entityApprovalAction.entityApprovalDto.detail &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.subject &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.subject.name}{" "}
                                <br />{" "}
                                {ele.entityApprovalAction.entityApprovalDto.detail &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.subject &&
                                  ele.entityApprovalAction.entityApprovalDto.detail.subject.nameDvng}
                              </td>
                              <td >
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>

                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.firstName
                                }{" "}
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.lastName
                                }
                              </td>

                              <td className=" word-break">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-12">
                                {(session.roleName == 'superadmin' || session.roleName == 'desk officer') &&
                                  <button
                                    type="button"
                                    className="pull-right btn btn-outline-primary btn-sm custom-button"
                                    onClick={() => {
                                      handleApprovalUser(ele);
                                    }}
                                  >
                                    {label.REVIEW}
                                  </button>}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_verion_mismatch_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={allUnapprovalVersionMismatchList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>
          <div
            className={
              stepName === "invigilator"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="invigilator"
            role="tabpanel"
            aria-labelledby="invigilator-tab"
          >
            <InvigilatorVersionMismatch key={stepName} />
          </div>

        </div>

        {approvalEntityModal && (
          <ApprovalVersionMismatchEntity
            showModal={approvalEntityModal}
            setShowModal={setApprovalEntityModal}
            setSelectedApprovalEntity={selectedApprovalEntity}
          />
        )}
      </div>
      {viewImageModal && (
        <FileViewModal
          showModal={viewImageModal}
          setShowModal={setViewImageModal}
          fileId={selectedImageContent}
        />
      )}
    </div>
  );
};

export default VersionMismatch;
